'use strict';

require('./frontdesk.css');
require('./frontdesk-kioskPayments.controller.js');

angular.module('cgmemApp')
	.config(function ($stateProvider) {
		$stateProvider
			.state('authenticated.frontdesk', {
				url: '/frontdesk',
				templateUrl: 'app/frontdesk/frontdesk.html',
				controller: function ($rootScope, $state, $log) {
					$rootScope.$on('$stateChangeSuccess',
						function (event, toState, toParams, fromState, fromParams) {
							if (toState.name == 'authenticated.frontdesk')
								$state.go('authenticated.frontdesk.frame.search');
						});
					$state.go('authenticated.frontdesk.frame.search')
				}
			})
			.state('authenticated.frontdesk.frame', {
				views: {
					'notices': {
						templateUrl: 'app/frontdesk/frontdesk-notices.html',
						controller: 'FrontDeskNoticeCtrl',
						controllerAs: 'nc'
					},
					'checkin': {
						template: '<div class="ui-view"></div>',
					},
					'kioskPayments': {
						templateUrl: 'app/frontdesk/frontdesk-kioskPayments.html',
						controller: 'FrontDeskKioskPaymentsCtrl',
						controllerAs: 'kioskPayments'
					},
					'autocheckin': {
						templateUrl: 'app/frontdesk/frontdesk-autocheckin.html',
						controller: 'FrontDeskAutoCheckInCtrl',
						controllerAs: 'autocheckin'
					}
				}
			})
			.state('authenticated.frontdesk.frame.search', {
				templateUrl: 'app/frontdesk/frontdesk-search.html',
				controller: 'FrontDeskSelectCtrl',
				controllerAs: 'checkins'

			})
			.state('authenticated.frontdesk.frame.checkin', {
				params: {
					selectedAccount: null
				},
				templateUrl: 'app/frontdesk/frontdesk-checkin.html',
				controller: 'FrontDeskCheckInCtrl',
				controllerAs: 'checkins'
			})
			.state('authenticated.frontdesk.frame.guests', {
				params: {
					accountId: null,
					hostMemberId: null,
					guestQty: 0
				},
				templateUrl: 'app/frontdesk/frontdesk-guests.html',
				controller: 'FrontDeskGuestsCtrl',
				controllerAs: 'checkins'
			});
	});